import { parse, print } from 'graphql'

export const operationTemplates = [
  {
    id: 'dailyCalculators',
    label: 'คำนวนดอกเบี้ยรายวัน',
    description:
      'คำนวณดอกเบี้ยรายวันสำหรับสัญญาที่เข้าเงื่อนไขเดียวกับ cron โดยมีการบันทึกข้อมูลจริง ใช้ตัวแปร {} และต้องพิมพ์ RUN_DAILY_CALCULATORS เพื่อยืนยันก่อนเริ่ม ปิดหน้าเว็บไม่ได้ยกเลิกงาน หากการเชื่อมต่อขัดข้องให้ตรวจสอบผลก่อนเรียกซ้ำ',
    command: `mutation DailyCalculators {
  dailyCalculators {
    id
    contractNo
    contractName
  }
}`,
    variables: '{}',
  },
  {
    id: 'getPendingDailyCalculations',
    label: 'ตรวจสอบสัญญาที่ยังไม่ได้คำนวณดอกเบี้ยรายวัน',
    description:
      'ตรวจสัญญาที่เข้าเงื่อนไข cron และยังไม่มีรายการดอกเบี้ยของเมื่อวาน (targetDate) โดยไม่สั่งคำนวณหรือแก้ยอดเงิน ค่าเริ่มต้น sendEmail: false ไม่ส่งเมล เปลี่ยนเป็น true เพื่อส่งรายการค้างทั้งหมดไปยังผู้รับเดิม แม้ไม่มีรายการค้างก็ส่งเมลแจ้ง เปลี่ยน page เพื่อดูหน้าถัดไป และกำหนด pageSize ได้ 1–100 รายการ lastCalculationDate เป็น null หมายถึงยังไม่พบรายการดอกเบี้ย emailStatus: SENT หมายถึง SMTP รับอีเมลแล้ว, DISABLED คือปิดส่งใน environment นี้, NOT_REQUESTED คือไม่ได้ขอส่ง ผลตรวจไม่ใช่การยืนยันว่างานคำนวณทุกขั้นตอนเสร็จสมบูรณ์',
    command: `mutation GetPendingDailyCalculations($page: Int!, $pageSize: Int!, $sendEmail: Boolean = false) {
  getPendingDailyCalculations(page: $page, pageSize: $pageSize, sendEmail: $sendEmail) {
    targetDate
    page
    pageSize
    total
    emailStatus
    items {
      id
      contractNo
      contractName
      lastCalculationDate
    }
  }
}`,
    variables: '{\n  "page": 1,\n  "pageSize": 50,\n  "sendEmail": false\n}',
  },
  {
    id: 'clearDatabaseLogs',
    label: 'ล้างประวัติระบบ (Local Dev)',
    developmentOnly: true,
    description:
      'เฉพาะ local development: ล้างประวัติที่เกินระยะเวลาเก็บของระบบ เริ่มด้วย dryRun: true เพื่อตรวจสอบจำนวนโดยไม่ลบข้อมูล เปลี่ยนเป็น false เพื่อเข้าสู่ขั้นตอนยืนยันลบ โดยคง confirmation เป็น null และพิมพ์ CLEAR_DATABASE_LOGS ในหน้าต่างยืนยัน การลบกู้คืนไม่ได้หากไม่มีข้อมูลสำรอง ปิดหน้าเว็บไม่ได้ยกเลิกงาน',
    command: `mutation ClearDatabaseLogs($dryRun: Boolean!, $confirmation: String) {
  clearDatabaseLogs(dryRun: $dryRun, confirmation: $confirmation) {
    dryRun
    startedAt
    completed
    results {
      name
      enabled
      months
      days
      cutoff
      eligible
      deleted
      detailEligible
      detailDeleted
      skipped
      errorCode
    }
  }
}`,
    variables: '{\n  "dryRun": true,\n  "confirmation": null\n}',
  },
  {
    id: 'randomDraftApprovedContracts',
    label: 'สุ่มสัญญา Approved → Draft → Approved (Local Dev)',
    developmentOnly: true,
    description:
      'เฉพาะ local development: สุ่มสัญญา Approved ที่เปิดใช้งานและไม่ใช่สัญญาปรับโครงสร้างหนี้ กำหนด count 1–100 (ค่าเริ่มต้น 1) เพิ่ม startDate เช่น "2026-01-01" เพื่อกรอง Contract.contractLoanDate ตั้งแต่วันที่ระบุรวมวันนั้นด้วย ไม่ส่งหรือ null คือไม่กรองวันที่ ใช้ flow เดียวกับปุ่มหน้าสัญญา Draft จะลบ Transaction และรีเซ็ตยอดคำนวณ แล้ว Approved กลับทันที แต่ไม่สั่งคำนวณใหม่อัตโนมัติ หากรายการใดผิดพลาดให้ rollback ข้อมูลธุรกิจทั้งชุด ส่วน log ยังคงอยู่ จำกัด transaction 60 วินาที ไม่มี retry หากการเชื่อมต่อขาดให้ตรวจผลก่อนทำซ้ำ ต้องสำรองข้อมูลและพิมพ์ RANDOM_DRAFT_APPROVED เพื่อยืนยัน',
    command: `mutation RandomDraftApprovedContracts($count: Int!, $confirmation: String!, $startDate: String) {
  randomDraftApprovedContracts(count: $count, confirmation: $confirmation, startDate: $startDate) {
    runId
    completed
    count
    contractIds
  }
}`,
    variables:
      '{\n  "count": 1,\n  "startDate": null,\n  "confirmation": ""\n}',
  },
  {
    id: 'randomRollbackDailyCalculations',
    label: 'สุ่มย้อนวันที่คำนวนดอกเบี้ย (Local Dev)',
    developmentOnly: true,
    description:
      'เฉพาะ local development: สุ่มสัญญา Approved ที่เปิดใช้งาน ไม่ใช่สัญญาปรับโครงสร้างหนี้ และ Contract.contractLoanDate ต้องอยู่ก่อน date จากนั้นเรียก flow เดียวกับปุ่ม “ย้อนวันที่คำนวนดอกเบี้ย” ของแต่ละสัญญา โดยส่ง extra: false กำหนด count 1–100 และ date เป็น YYYY-MM-DD หากรายการใดผิดพลาดข้อมูลธุรกิจทั้งชุดจะ rollback แต่ log ที่สร้างในฐาน log อาจคงอยู่ จำกัดเวลาชุดละ 5 นาที ไม่มี retry หากการเชื่อมต่อขาดให้ตรวจผลก่อนทำซ้ำ ต้องสำรองข้อมูลและพิมพ์ RANDOM_ROLLBACK_DAILY_CALCULATIONS เพื่อยืนยัน',
    command: `mutation RandomRollbackDailyCalculations($count: Int!, $date: String!, $confirmation: String!) {
  randomRollbackDailyCalculations(count: $count, date: $date, confirmation: $confirmation) {
    runId
    completed
    count
    contractIds
  }
}`,
    variables:
      '{\n  "count": 1,\n  "date": "2026-01-01",\n  "confirmation": ""\n}',
  },
]

// UI scope only. Backend authorizes both queries and mutations.
export function prepareOperation(templateId, command, variablesText) {
  const template = operationTemplates.find((item) => item.id === templateId)
  if (!template) throw new Error('กรุณาเลือกเทมเพลตคำสั่ง')
  if (template.developmentOnly && process.env.NODE_ENV !== 'development')
    throw new Error('คำสั่งนี้อนุญาตเฉพาะ development เท่านั้น')
  let document
  let variables
  try {
    document = parse(command)
  } catch (_) {
    throw new Error('รูปแบบคำสั่ง GraphQL ไม่ถูกต้อง')
  }
  try {
    variables = JSON.parse(variablesText)
  } catch (_) {
    throw new Error('ตัวแปรต้องเป็น JSON ที่ถูกต้อง')
  }
  if (!variables || Array.isArray(variables) || typeof variables !== 'object')
    throw new Error('ตัวแปรต้องเป็น JSON object')
  const operation = document.definitions[0]
  const expected = parse(template.command).definitions[0]
  if (
    document.definitions.length !== 1 ||
    operation.kind !== 'OperationDefinition' ||
    operation.operation !== expected.operation ||
    operation.directives.length ||
    operation.selectionSet.selections.length !== 1
  )
    throw new Error(
      'หน้านี้รองรับ operation เดียวตามประเภทของเทมเพลตที่เลือกเท่านั้น'
    )
  const field = operation.selectionSet.selections[0]
  if (
    field.kind !== 'Field' ||
    field.name.value !== templateId ||
    field.alias ||
    field.directives.length ||
    field.arguments.map(print).join() !==
      expected.selectionSet.selections[0].arguments.map(print).join() ||
    operation.variableDefinitions.map(print).join() !==
      expected.variableDefinitions.map(print).join()
  )
    throw new Error(
      'กรุณาคงชื่อ operation และตัวแปรตามเทมเพลต ปรับได้เฉพาะ fields ผลลัพธ์'
    )
  if (templateId === 'dailyCalculators' && Object.keys(variables).length)
    throw new Error('คำนวณดอกเบี้ยรายวันไม่รับตัวแปร ใช้ {}')
  if (
    templateId === 'randomDraftApprovedContracts' &&
    (Object.keys(variables).some(
      (key) => !['count', 'confirmation', 'startDate'].includes(key)
    ) ||
      !Number.isInteger(variables.count) ||
      variables.count < 1 ||
      variables.count > 100 ||
      (variables.confirmation !== undefined && variables.confirmation !== ''))
  )
    throw new Error(
      'กำหนด count เป็นจำนวนเต็ม 1–100 และ confirmation เป็นข้อความว่าง ยืนยันผ่านหน้าต่างยืนยันเท่านั้น'
    )
  if (
    templateId === 'randomDraftApprovedContracts' &&
    variables.startDate != null
  ) {
    const value = variables.startDate
    const date =
      typeof value === 'string'
        ? new Date(`${value}T00:00:00.000Z`)
        : new Date(NaN)
    if (
      typeof value !== 'string' ||
      !/^\d{4}-\d{2}-\d{2}$/.test(value) ||
      value.startsWith('0000') ||
      Number.isNaN(date.getTime()) ||
      date.toISOString().slice(0, 10) !== value
    )
      throw new Error(
        'startDate ต้องเป็นวันที่จริงรูปแบบ YYYY-MM-DD หรือ null โดยกรอง Contract.contractLoanDate ตั้งแต่วันที่ระบุ'
      )
  }
  if (
    templateId === 'randomRollbackDailyCalculations' &&
    (Object.keys(variables).some(
      (key) => !['count', 'date', 'confirmation'].includes(key)
    ) ||
      !Number.isInteger(variables.count) ||
      variables.count < 1 ||
      variables.count > 100 ||
      (variables.confirmation !== undefined && variables.confirmation !== ''))
  )
    throw new Error(
      'กำหนด count เป็นจำนวนเต็ม 1–100, date เป็น YYYY-MM-DD และ confirmation เป็นข้อความว่าง ยืนยันผ่านหน้าต่างยืนยันเท่านั้น'
    )
  if (templateId === 'randomRollbackDailyCalculations') {
    const value = variables.date
    const date =
      typeof value === 'string'
        ? new Date(`${value}T00:00:00.000Z`)
        : new Date(NaN)
    if (
      typeof value !== 'string' ||
      !/^\d{4}-\d{2}-\d{2}$/.test(value) ||
      value.startsWith('0000') ||
      Number.isNaN(date.getTime()) ||
      date.toISOString().slice(0, 10) !== value
    )
      throw new Error('date ต้องเป็นวันที่จริงรูปแบบ YYYY-MM-DD')
  }
  if (templateId === 'clearDatabaseLogs') {
    if (
      Object.keys(variables).some(
        (key) => !['dryRun', 'confirmation'].includes(key)
      ) ||
      typeof variables.dryRun !== 'boolean' ||
      (variables.confirmation !== undefined &&
        variables.confirmation !== null &&
        variables.confirmation !== '')
    )
      throw new Error(
        'กำหนด dryRun เป็น true/false และ confirmation เป็น null; ยืนยันการลบผ่านหน้าต่างยืนยันเท่านั้น'
      )
  }
  if (
    templateId === 'getPendingDailyCalculations' &&
    (Object.keys(variables).some(
      (key) => !['page', 'pageSize', 'sendEmail'].includes(key)
    ) ||
      (variables.sendEmail !== undefined &&
        typeof variables.sendEmail !== 'boolean') ||
      !Number.isInteger(variables.page) ||
      variables.page < 1 ||
      variables.page > 100000 ||
      !Number.isInteger(variables.pageSize) ||
      variables.pageSize < 1 ||
      variables.pageSize > 100)
  )
    throw new Error('กำหนด page ระหว่าง 1–100000 และ pageSize ระหว่าง 1–100')
  return { document, variables, templateId, operation: operation.operation }
}
